class ExternalLinkPromptPopup {
	constructor() {
		this.popup = document.querySelector('[data-id="externalLinkPromptPopup"]');
		if (!this.popup) return;

		this.linkDisplay = this.popup.querySelector('.js-linkDisplay');
		this.yesLink = this.popup.querySelector('.js-yesLink');

		Array.from(document.querySelectorAll('.js-externalLink')).forEach(link =>
			link.addEventListener('click', this.onClick.bind(this))
		);
	}

	onClick(e) {
		e.preventDefault();
		this.linkDisplay.innerText = e.currentTarget.href;
		this.linkDisplay.href = e.currentTarget.href;
		this.yesLink.href = e.currentTarget.href;
		this.popup.classList.add('is-open');
	}
}
new ExternalLinkPromptPopup();
